import request from '@/utils/request'
import Setting from '../settings'
const {
  interFaceDomain
} = Setting
// 获取任务统计
export function statistics(parmas) {
  return request({
    url: interFaceDomain+'/front/tReception/nearlyHalfYearMission',
    method: 'get',
    parmas
  })
}
// 任务总览
export function taskTotal(parmas) {
  return request({
    url: interFaceDomain+'/front/tReception/getTrafficDataOverview',
    method: 'get',
    parmas
  })
}

